import React from 'react';
import { Icon } from './AdminShell';

/*
 * Arketipe formulir (D + E paket client) — pasangan DataTable untuk layar
 * pengaturan. Sekitar 16 dari 33 tujuan memakainya: Payment gateways, Site
 * settings, Mobile apps, Pricing, Promo codes, dan seterusnya.
 *
 * Diport dari `form()`, `field()` dan `settingRow()` di prototype/js/ui.js,
 * memakai nama kelas dari app.css supaya markupnya pindah nyaris apa adanya.
 *
 * Dibuat terkendali (controlled): tiap nilai datang dari state pemanggil dan
 * tiap perubahan naik lewat onChange. Prototipe membaca DOM kembali saat
 * disimpan; itu tidak bisa dipakai di React tanpa membuat dua sumber kebenaran.
 */

export const Fieldset = ({ title, desc, rows, children }) => (
  <div className="fieldset">
    {title && <h3>{title}</h3>}
    {desc && <p>{desc}</p>}
    {rows ? <div>{children}</div> : <div className="form-grid">{children}</div>}
  </div>
);

export const Switch = ({ checked, onChange, label, disabled }) => (
  <label className="switch">
    <input type="checkbox" checked={!!checked} disabled={disabled}
      aria-label={label} onChange={e => onChange(e.target.checked)} />
    <span className="tr" />
    <span className="kn" />
  </label>
);

/*
 * Satu baris pengaturan: keterangan di kiri, kontrol di kanan.
 * `note` dipakai untuk hal yang membuat kontrolnya tidak bisa dipakai —
 * mengapa sebuah saklar terkunci lebih berguna daripada saklar yang mati
 * tanpa penjelasan.
 */
export const SettingRow = ({ label, hint, note, children }) => (
  <div className="setting-row">
    <div className="txt">
      <b>{label}</b>
      {hint && <span>{hint}</span>}
      {note && <span style={{ color: 'var(--warn)' }}>{note}</span>}
    </div>
    {children}
  </div>
);

export const Field = ({ label, hint, error, required, span, children, htmlFor }) => (
  <div className={`field${span ? ' span2' : ''}`}>
    {label && (
      <label htmlFor={htmlFor}>
        {label}{required && <span style={{ color: 'var(--danger)' }}> *</span>}
      </label>
    )}
    {children}
    {error ? <span className="err">{error}</span> : (hint && <span className="hint">{hint}</span>)}
  </div>
);

/*
 * Kaki formulir. Tombol simpan MATI selama tidak ada yang berubah — tombol
 * simpan yang selalu bisa ditekan mengajarkan orang menekannya tanpa berpikir,
 * dan pada layar yang mengubah cara pembayaran itu kebiasaan yang mahal.
 */
export const FormActions = ({ note, dirty, busy, onSave, onCancel, saveLabel = 'Save changes', cancelLabel = 'Cancel', busyLabel = 'Saving…' }) => (
  <div className="form-actions">
    <span className="sp">{note}</span>
    <button className="btn ghost" type="button" onClick={onCancel} disabled={!dirty || busy}>
      {cancelLabel}
    </button>
    <button className="btn" type="button" onClick={onSave} disabled={!dirty || busy}>
      <Icon name="check" />{busy ? busyLabel : saveLabel}
    </button>
  </div>
);

export const FormCard = ({ children, actions }) => (
  <section className="card">
    <div className="card-b">{children}</div>
    {actions}
  </section>
);
